// extracted by mini-css-extract-plugin
export default {"label":"Checkbox_label__2jhHe","checkbox":"Checkbox_checkbox__4anjR"};